import type { ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material/styles'
import { MetricState } from './index'
import MetricStateIndicator from './MetricStateIndicator'

type MetricStatePlaceholderProps = {
  state?: MetricState | null
  /** Overrides the default description for the given state. */
  message?: ReactNode
  minHeight?: number
  sx?: SxProps<Theme>
}

/**
 * Static placeholder for terminal, non-success metric states (NO_RUN, NO_DATA,
 * FAILED). Active states (QUEUED/RUNNING) and SUCCEEDED render nothing.
 */
const MetricStatePlaceholder = ({ state, message, minHeight = 80, sx }: MetricStatePlaceholderProps) => {
  if (state === MetricState.QUEUED || state === MetricState.RUNNING || state === MetricState.SUCCEEDED) return null
  return <MetricStateIndicator state={state} variant="block" message={message} minHeight={minHeight} sx={sx} />
}

export default MetricStatePlaceholder
